import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [checking, setChecking] = useState(true);
  const [hasSession, setHasSession] = useState(false);

  useEffect(() => {
    let isMounted = true;

    // Fast path: getSession() reads localStorage synchronously-ish and resolves
    // immediately for already-logged-in users, so there's no visible flash.
    supabase.auth.getSession().then(({ data }) => {
      if (!isMounted) return;
      if (data.session) {
        setHasSession(true);
        setChecking(false);
      }
      // If no session yet, wait for onAuthStateChange (handles OAuth PKCE exchange)
    }).catch(() => { if (isMounted) setChecking(false); });

    // Handles OAuth callback: detectSessionInUrl exchanges the code async, then
    // fires SIGNED_IN here. Also handles token refresh and sign-out.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!isMounted) return;
      setHasSession(!!session);
      setChecking(false);
    });

    return () => {
      isMounted = false;
      subscription.unsubscribe();
    };
  }, []);

  if (checking) return null;
  if (!hasSession) return <Navigate to="/login" replace />;

  return <>{children}</>;
}

